// extracted by mini-css-extract-plugin
export default {"main":"PageNotFound_main__qP-ua","fof":"PageNotFound_fof__2kDY6","type":"PageNotFound_type__cpUab"};